import { ReactNode, InputHTMLAttributes } from 'react';

export interface Option<T> {
    name: string;
    value: T;
    note?: string;
    /** Default: false */
    isInlineNote?: boolean;
    /** Default: false */
    disabled?: boolean;
    /** Instead of tick icon, always visible */
    icon?: ReactNode;
}

export enum OptionListHeight {
    Hold = 'hold',
    Range = 'range',
}
export interface OptionListProps<T extends InputHTMLAttributes<HTMLInputElement>['value']> {
    options: readonly Option<T>[];
    value: Option<T> | null;
    onSelect: (option: Option<T>) => void;
    heightType?: OptionListHeight;
}
